<template>
  <template v-if="$auth.check()">
    <nav-bar></nav-bar>
    <router-view></router-view>
  </template>
  <template v-else>
    <Login/>
  </template>
</template>

<script>
import Login from "@/components/auth/Login.vue";
import NavBar from "@/components/layout/NavBar.vue";
import ApiRequest from "@/core/api-request";

export default {
  name: 'App',
  components: {
    NavBar,
    Login
  },
  mounted() {
    ApiRequest.init(this.$auth)
  }
}
</script>

<style>

</style>
